import {
  Avatar,
  Badge,
  Button,
  Flex,
  Td,
  Text,
  Icon,
  Tr,
  Link,
  useColorModeValue
} from "@chakra-ui/react";
import React from "react";
import config from "config/index";
import { RiHotelLine } from "react-icons/ri";
import IconBox from "components/Icons/IconBox";
import { useHistory,useLocation } from "react-router-dom";

function TablesTableRow(props) {
const history = useHistory();
  const { logo, name, address, night, date,gallery,feed,controlpanel, isLast } = props;
  const textColor = useColorModeValue("gray.500", "white");
  const titleColor = useColorModeValue("gray.700", "white");
  const bgStatus = useColorModeValue("gray.400", "navy.900");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  return (
    <Tr>
      <Td
        minWidth={{ sm: "250px" }}
        pl="0px"
        borderColor={borderColor}
        borderBottom={isLast ? "none" : null}
      >
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
        <IconBox ml={"20px"} as='box' >
                            <Icon h={"25px"} w={"25px"} color={titleColor} as={RiHotelLine} />
                          </IconBox>
          <Flex direction="column">
            <Text
              fontSize="sm"
              color={titleColor}
              fontWeight="bold"
              minWidth="100%"
            >
              {name}
            </Text>
            <Text fontSize="xs" color="gray.400" fontWeight="normal">
              {address}
            </Text>
          </Flex>
        </Flex>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Badge
          bg="blue.400"
          color="white"
          fontSize="xs"
          p="3px 10px"
          borderRadius="8px"
        >
          <Link fontSize="xs" 
            color='white'
            target="_blank"
            href={config.host+"/tour/"+address}>
            مشاهده
          </Link>
        </Badge>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Badge
          bg={feed === true ? "green.400" : bgStatus}
          color={feed === true ? "white" : "white"}
          fontSize="xs"
          p="3px 10px"
          borderRadius="8px"
        >
          {feed==true?"فعال":"غیرفعال"}
        </Badge>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Badge
          bg={night === true ? "green.400" : bgStatus}
          color={night === true ? "white" : "white"}
          fontSize="xs"
          p="3px 10px"
          borderRadius="8px"
        >
          {night==true?"فعال":"غیرفعال"}
        </Badge>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Text fontSize="xs" color={textColor} fontWeight="bold" dir="ltr" textAlign="right" pb=".5rem">
          {date}
        </Text>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Link onClick={()=>history.push("/admin/tour/details/"+address)} p="0px"  >
          <Text
            fontSize="xs"
            color="gray.400"
            fontWeight="bold"
            cursor="pointer">
            ویرایش
          </Text>
        </Link>
      </Td>
    </Tr>
  );
}

export default TablesTableRow;
